<template>
  <div class="md:w-6/12 mx-auto">
    <div class="flex justify-between">
      <FormInput
        v-model="cholesterol"
        class="w-2/3"
        size="small"
        :disabled="isUnknown"
        name="cholesterol"
        :hasError="hasError"
        type="number"
      />
      <div class="flex self-center">
        <p class="h4">mg/dL</p>
      </div>
    </div>
    <div class="inline-block mt-12 bg-grey-50 py-10 px-20 rounded-md">
      <input
        type="checkbox"
        class="mr-8 inline-block"
        :checked="!!isUnknown"
        @change="handleCheckEvent"
      />
      <p class="inline-block">
        {{ $t('questionnaire.question.cholesterol') }}
      </p>
    </div>
  </div>
</template>

<script>
import FormInput from '../../../common/forms/FormInput'
import cholesterolMixin from '@platform-shared/mixins/questionnaire/question-types/cholesterol'

export default {
  components: { FormInput },
  mixins: [cholesterolMixin],
  methods: {
    handleCheckEvent(event) {
      this.handleCheck({ value: event.target.checked })
    },
  },
}
</script>
